export default "__VITE_ASSET__BwdSn4Jy__"